import React from 'react';
import Base from './Base';

export default (props) => (
  <Base {...props}>
    <path d="M25,11C12.3,11,2,25,2,25S12.3,39,25,39,48,25,48,25,37.7,11,25,11Zm0,21a7,7,0,1,1,7-7A7,7,0,0,1,25,32Z" />
  </Base>
);
